import React from 'react';
import { IconButton, Tooltip } from '@mui/material';

/**
 * An icon-only button with its tooltip. The tooltip shows `label`, which is
 * also what screen readers announce (pass `ariaLabel` to add detail, e.g. the
 * record's name). When `disabledReason` is set the button is disabled and the
 * tooltip says why instead. Every icon-only button in the app should be one
 * of these.
 */
const IconAction = React.forwardRef(
  ({ label, ariaLabel, icon, disabledReason, disabled = false, placement, children, ...props }, ref) => {
    const off = Boolean(disabledReason) || disabled;
    const button = (
      <IconButton ref={ref} aria-label={ariaLabel || label} disabled={off} {...props}>
        {icon || children}
      </IconButton>
    );
    return (
      <Tooltip title={disabledReason || label} placement={placement}>
        {/* A disabled button gets no pointer events, so its tooltip needs a wrapper. */}
        {off ? <span style={{ display: 'inline-flex' }}>{button}</span> : button}
      </Tooltip>
    );
  }
);

export default IconAction;
